import { TrackReferenceOrPlaceholder } from '@livekit/components-react';
import { Track } from 'livekit-client';
import { ParticipantTrack } from '../services/LiveKitService';
import { LiveKitFeedConfig } from '../types/feed';

export function convertParticipantTrackToTrackReference(
  participantTrack: ParticipantTrack,
): TrackReferenceOrPlaceholder {
  return {
    participant: participantTrack.participant,
    publication: participantTrack.publication,
    source: participantTrack.source,
  };
}

export function createLiveKitFeedConfigFromTrack(
  participantTrack: ParticipantTrack,
  roomName: string,
  podId: string,
): LiveKitFeedConfig {
  const trackReference =
    convertParticipantTrackToTrackReference(participantTrack);

  // Create a descriptive name for the feed
  const feedName = `${podId} - ${participantTrack.participantIdentity} (${getSourceDisplayName(participantTrack.source)})`;

  // Create unique ID combining room, participant, and track
  const feedId = `livekit-${roomName}-${participantTrack.participantId}-${participantTrack.trackId}`;

  return {
    id: feedId,
    type: 'livekit',
    name: feedName,
    roomName,
    participantIdentity: participantTrack.participantIdentity,
    track: trackReference,
  };
}

export function createLiveKitFeedConfigsFromVideoTracks(
  videoTracks: ParticipantTrack[],
  roomName: string,
  podId: string,
): LiveKitFeedConfig[] {
  return videoTracks.map((track) =>
    createLiveKitFeedConfigFromTrack(track, roomName, podId),
  );
}

function getSourceDisplayName(source: Track.Source): string {
  switch (source) {
    case Track.Source.Camera:
      return 'Camera';
    case Track.Source.ScreenShare:
      return 'Screen Share';
    case Track.Source.Microphone:
      return 'Microphone';
    case Track.Source.ScreenShareAudio:
      return 'Screen Audio';
    default:
      return 'Unknown';
  }
}

export function isVideoTrack(track: ParticipantTrack): boolean {
  return (
    track.source === Track.Source.Camera ||
    track.source === Track.Source.ScreenShare
  );
}

export function filterVideoTracks(
  tracks: ParticipantTrack[],
): ParticipantTrack[] {
  return tracks.filter(isVideoTrack);
}
